angular.module('TetherApp').factory('marketingPlacementDetailService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let create = function (name, placementId, campaignId) {

            let uri = '/api/v1/marketing-placement-detail/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.put(
                uri,
                {
                    name: name,
                    placement_id : placementId,
                    campaign_id : campaignId
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let list = function (placementId, channelId) {

            let uri = '/api/v1/marketing-placement-detail/'
                + placementId
                + '/'
                + channelId
                + '/'
                + randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                },
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            create: create,
            list: list
        }
    }
]);
